import _ from "lodash";

export let formatNumber: (number) => string;

// Add commas in all modern browsers
if (_.isUndefined(Intl)) {
  formatNumber = _.toString;
} else {
  let nf = new Intl.NumberFormat("en-US");
  formatNumber = n => nf.format(n);
}
